export const shortenFileName = (name, maxLength = 25) => {
  if (!name) return "";
  if (name.length <= maxLength) return name;

  const start = name.slice(0, 15);
  const end = name.slice(-8);

  return `${start}...${end}`;
};